// extracted by mini-css-extract-plugin
export default {"cls1":"KnSnE1euhgNXIRpUtpZS","cls2":"kGSUyJc53s2f9Fswcsd3 KnSnE1euhgNXIRpUtpZS"};